export enum UnecoCategoryName {
  TODOS,
  TEXTIL,
  CALZADO,
  COMPLEMENTO
}
